'use client';

import { c as _c } from "react/compiler-runtime";
import AutoplayVisibleVideo from '@/components/AutoplayVisibleVideo';
import ShowcaseBlock1 from '@/public/images/partner/showcase-block-1.png';
import ShowcaseBlock2 from '@/public/images/partner/showcase-block-2.png';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image, { StaticImageData } from 'next/image';
interface CategoryTag {
  label: string;
}
interface FeatureCategory {
  titleKey: string;
  subtitleKey: string;
  imageUrl: StaticImageData | string;
  isVideo?: boolean;
  isFlipped?: boolean;
  tags: CategoryTag[];
}
const FEATURE_CATEGORIES: FeatureCategory[] = [{
  titleKey: 'partner.content-showcase.games.title',
  subtitleKey: 'partner.content-showcase.games.subtitle',
  imageUrl: ShowcaseBlock1,
  tags: [{
    label: 'Action'
  }, {
    label: 'RPG'
  }, {
    label: 'Indie'
  }, {
    label: 'Adventure'
  }]
}, {
  titleKey: 'partner.content-showcase.videos.title',
  subtitleKey: 'partner.content-showcase.videos.subtitle',
  imageUrl: ShowcaseBlock1,
  isVideo: true,
  tags: [{
    label: 'Podcasts'
  }, {
    label: 'Tutorials'
  }, {
    label: 'Reviews'
  }, {
    label: 'Music Videos'
  }]
}, {
  titleKey: 'partner.content-showcase.apps.title',
  subtitleKey: 'partner.content-showcase.apps.subtitle',
  imageUrl: ShowcaseBlock2,
  isFlipped: true,
  tags: [{
    label: 'Tools'
  }, {
    label: 'Social'
  }, {
    label: 'Demos'
  }, {
    label: 'Productivity'
  }]
}];
export default function ContentShowcase() {
  const $ = _c(22);
  const t = useTranslations();
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      y: 20
    };
    t1 = {
      opacity: 1,
      y: 0
    };
    t2 = {
      once: true,
      amount: 0.2
    };
    t3 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t.rich("partner.content-showcase.heading-part1", {
      word: t("partner.content-showcase.heading-part2"),
      span: _temp
    });
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex justify-center gap-3 text-center text-[28px] leading-[30px] font-extrabold tracking-[0.15px] md:flex-row md:text-[38px] md:leading-10">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("partner.content-showcase.description");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <p className="text-vive-primary-20 text-center text-base leading-[26px] tracking-[0.25px] md:text-[18px] md:leading-8 lg:w-[51%]">{t6}</p>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <motion.div initial={t0} whileInView={t1} viewport={t2} transition={t3}><div className="flex flex-col items-center gap-2 md:gap-3">{t5}{t7}</div></motion.div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = FEATURE_CATEGORIES.map((category, index) => <motion.div key={index} className="flex flex-col gap-6" initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.6,
      ease: "easeOut",
      delay: index * 0.12
    }}><div className="relative flex items-center justify-center">{category.isVideo ? <div className="relative h-[347px] w-full overflow-hidden rounded-2xl"><AutoplayVisibleVideo className="bg-creator-intro-hero-introduce-card absolute inset-0 flex size-full w-full flex-col gap-3 object-cover" src="/videos/partner/showcase-block.mp4" autoPlay={true} muted={true} loop={true} playsInline={true} /><div className="pointer-events-none absolute top-0 right-0 left-0 h-1/3 rounded-t-2xl bg-linear-to-b from-black/50 to-transparent" /></div> : <div className="relative h-[347px] w-full overflow-hidden rounded-2xl"><Image alt={t(category.titleKey)} src={category.imageUrl} width={400} height={347} className="h-full w-full object-cover" /><div className="pointer-events-none absolute top-0 right-0 left-0 h-1/3 rounded-t-2xl bg-linear-to-b from-black/50 to-transparent" /></div>}</div><div className="flex flex-col gap-2"><h3 className="text-[20px] leading-7 font-bold text-white">{t(category.titleKey)}</h3><p className="text-vive-primary-20 text-[14px] leading-5">{t(category.subtitleKey)}</p><div className="flex flex-wrap gap-2">{category.tags.map(_temp2)}</div></div></motion.div>);
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <div className="flex flex-col gap-6 md:grid md:grid-cols-2 lg:grid-cols-3">{t9}</div>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8) {
    t11 = <section className="bg-background relative flex flex-col items-center justify-center px-4 py-12 md:px-8 md:py-20 lg:px-18"><div className="flex w-full max-w-[1296px] flex-col gap-9 md:gap-12 lg:gap-4">{t8}{t10}</div></section>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}
function _temp2(tag, tagIndex) {
  return <div key={tagIndex} className="border-vive-surface-normal flex items-center rounded-md border px-[11px] py-1"><span className="text-vive-primary-20 text-[11px] leading-4">{tag.label}</span></div>;
}
function _temp(chunks) {
  return <span className="gradient-title-2">{chunks}</span>;
}